export { default } from "./getContentCategory";
